import { commonApiTypes } from 'types/common';

export const commonState: commonApiTypes.ICommon = {
    exception: {
        error: null,
    },
};
